/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var PersonIngestionRequest;
(function (PersonIngestionRequest) {
    let target;
    (function (target) {
        target["PERSON_SEARCH"] = "PERSON_SEARCH";
        target["CONTACT_SEARCH"] = "CONTACT_SEARCH";
    })(target = PersonIngestionRequest.target || (PersonIngestionRequest.target = {}));
})(PersonIngestionRequest || (PersonIngestionRequest = {}));
